import React from 'react'
import AutoCompleteSelect from '../UI/AutoCompleteSelect'

import Resource from '../../stores/resource'
const ReferenceValueStore = Resource('reference-values')

const ReferenceValueSelect = (props) => (
  <AutoCompleteSelect
    name='reference_value'
    floatingLabelText='Select a reference value (autocomplete)'
    selectedId={props.selectedId}
    dataStore={ReferenceValueStore}
    autoCompleteFilter='nameAutocomplete'
    autoCompleteAttribute='name'
    validatedOnChange={props.validatedOnChange}
    fullWidth={true}
    required={true}
    openOnFocus={true}
  />
)

export default ReferenceValueSelect



// WEBPACK FOOTER //
// ./src/components/ReferenceValues/ReferenceValueSelect.jsx